import { useContext } from 'react';
import { ImperativeComponentContext, TEventsHandlers, TMap } from './types';
import { TId } from '../../components/common/generic/tree/types';

/**
 * Permite el uso de eventos en herederos directos o no del imperativeComponent
 * más cercano.
 */
export default function useImperativeComponentContext<
  Events extends TMap = TMap,
>() {
  const context = useContext(ImperativeComponentContext) as {
    id: TId;
    eventsStore: TEventsHandlers<Events>;
  };

  return context;
}
